/** Maximum property title length in Unicode characters, matching PostgreSQL. */
export const PROPERTY_TITLE_MAX_LENGTH = 60;
